import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, pluck, take } from 'rxjs/operators';
import { SettlementStatementDetails, SettlementStatementSummary } from 'src/app/types';
import { StatementService } from '../statement.service';

@Component({
  selector: 'lohi-settlement-detail',
  templateUrl: './settlement-detail.component.html',
  styles: [
    `
      @media print {
        .print-flex-row {
          flex-direction: row;
        }
        .print-pt-2 {
          margin-top: 16px;
        }
        .text-red-500,
        .text-green-400,
        .text-gray-200,
        .text-gray-300,
        .text-gray-400,
        .text-gray-500,
        .text-gray-600,
        .text-gray-700,
        .text-gray-800,
        .text-gray-900 {
          color: black;
        }
      },
        div {
          break-inside: avoid;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettlementDetailComponent implements OnInit, AfterViewInit {
  @Input() public statementId: number;
  @Input() public summary: SettlementStatementSummary;
  @Input() public autoPrint: boolean;
  public statement$: Observable<SettlementStatementDetails>;

  constructor(private statementService: StatementService) {}

  public ngOnInit(): void {
    this.statement$ = this.statementService.getStatement$(this.statementId).pipe(pluck('statement'));
  }

  public ngAfterViewInit(): void {
    this.statement$
      .pipe(
        filter((s) => s?.id && s.lineItems?.length !== 0),
        take(1),
      )
      .subscribe(() => {
        if (this.autoPrint) {
          setTimeout(() => {
            window.print();
          }, 500);
        }
      });
  }
}
